import { Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { FaqsList } from '@/components/Faqs/list';
import { FaqsTree } from '@/components/Faqs/Tree';

import classes from './index.module.css';

const FAQS_VIEW_TYPE = 'faqsViewType';

const DataBasePage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isLocalMode = import.meta.env.VITE_MODE === 'local';
  const { hierarchyParentId } = location.state || {};

  const beforeType = sessionStorage.getItem(FAQS_VIEW_TYPE);
  const [activeTab, _setActiveTab] = useState<string | null>(beforeType || 'table');
  const setActiveTab = (tab: string | null) => {
    _setActiveTab(tab);
    sessionStorage.setItem(FAQS_VIEW_TYPE, tab || '');
  };

  useEffect(() => {
    if (!hierarchyParentId) return;
    setActiveTab('tree');
  }, [hierarchyParentId]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const toParam = urlParams.get('to');
    if (toParam === 'tree') {
      setActiveTab('tree');
    }

    return () => {
      sessionStorage.removeItem(FAQS_VIEW_TYPE);
    };
  }, []);

  if (isLocalMode) return <FaqsList />;

  return (
    <Tabs value={activeTab} onChange={setActiveTab} keepMounted={false} color="violet">
      <Tabs.List className={classes.tabsList}>
        <Tabs.Tab value="table" c={activeTab === 'table' ? 'violet' : ''}>
          {t('faqs.tab.table')}
        </Tabs.Tab>
        <Tabs.Tab value="tree" c={activeTab === 'tree' ? 'violet' : ''}>
          {t('faqs.tab.tree')}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="table" mt={20}>
        <FaqsList />
      </Tabs.Panel>
      <Tabs.Panel value="tree">
        <FaqsTree />
      </Tabs.Panel>
    </Tabs>
  );
};

export default DataBasePage;
